const getRandomNumber = (min, max) => Math.floor(Math.random() * max + min);

export default getRandomNumber;
